import labNoReducer from "./labNoReducer";

const updateLabNoReducers = {
    labNo: labNoReducer
};

export default updateLabNoReducers;